define('views/blocks/EdenredView',['jquery', 'underscore', 'backbone', 'app', 'SubView',
        'BtnSwitchView',
        'models/EdenredDataModel',
        'template!blocks/payments/edenred'
    ],
    function ($, _, Backbone, app, SubView,
              BtnSwitchView,
              EdenredDataModel,
              edenredTemplate) {

        function onIframeSuccess(event) {
            // listen iframe communication, with edenred_validation
            var data = event.data || false, type;
            if (!!data){
                type = data.type || false;
                if(type === 'edenred_validation'){
                    app.trigger('onEdenredIframeSuccess', data);
                }else if(type === 'edenred_optout'){
                    app.trigger('onEdenredIframeOptout', data);
                }
            }
        }

        window.addEventListener('message', onIframeSuccess, true);

        var EdenredView = Backbone.View.extend(SubView).extend({
            //
            className: 'edenred',
            //
            initialize: function (options) {

                var view = this;
                view.subviews = [];


                view.render();

            },
            render: function () {
                var view = this;
                view.$el.html(edenredTemplate({
                    edenred:EdenredDataModel
                }));

                view.stopListening();
                view.listenTo(app,'onEdenredIframeSuccess',view.onIframeSuccess);
                view.listenTo(app,'onEdenredIframeOptout',view.onIframeCancel);
                view.listenTo(EdenredDataModel,'change:status',view.onStatusChange);
                view.delegateEvents();

            },
            onStatusChange:function(){
                this.render();
            },
            onIframeSuccess: function (data) {
                if(data.status === 'success'){
                    var update = _(_(data).pick('auth','login','availableAmount')).defaults({sync:'fetched'});
                    EdenredDataModel.set(update);
                    this.trigger('complete');
                }else if(data.message){
                    app.alert(data.message);
                }else{
                    app.alert();
                }
            },
            onIframeCancel: function(){
                this.trigger('complete');
            }

        });

        return EdenredView;
    });

